import { useMutation } from '@tanstack/react-query';

import { CreateVoucherUsersPayload, CreateVoucherUsersResponse, createVoucherUsers } from '~/services/PromoService';

export function useCreateVoucherUsers() {
  return useMutation<CreateVoucherUsersResponse, Error, CreateVoucherUsersPayload>({
    mutationFn: async (payload) => createVoucherUsers(payload),
  });
}
